<footer class="footer">
  <div class="footer-head-wrapper">
    <div class="footer-head">
      <div class="footer-head-content">
        <div
          class="footer-logo-container"
          *ngIf="footerConfig?.displayBrandLogo"
        >
          <nibtravel-logo [config]="logoConfig"></nibtravel-logo>
        </div>
        <nav class="footer-nav" *ngIf="footerConfig?.quickLinks as nav">
          <ng-container *ngIf="nav?.custom; else defaultNav">
            <ng-content select="[quick-links]"></ng-content>
          </ng-container>
          <ng-template #defaultNav>
            <ng-container
              [ngTemplateOutlet]="quickLink"
              [ngTemplateOutletContext]="{
                block: 'left',
                nav: nav?.left
              }"
              *ngIf="nav?.left"
            ></ng-container>
            <ng-container
              [ngTemplateOutlet]="quickLink"
              [ngTemplateOutletContext]="{
                block: 'right',
                nav: nav?.right
              }"
              *ngIf="nav?.right"
            ></ng-container>
          </ng-template>
        </nav>
      </div>
      <hr class="footer-divider" />
    </div>
  </div>

  <div class="footer-content">
    <ng-container *ngIf="footerConfig?.customContent">
      <ng-content select="[footer-content]"></ng-content>
    </ng-container>

    <div
      id="footer-disclaimer"
      [innerHTML]="footerConfig?.disclaimer"
      *ngIf="footerConfig?.disclaimer"
    ></div>

    <div
      class="footer-provider"
      *ngIf="footerConfig ? footerConfig.poweredBy : true"
    >
      <nibtravel-icon
        class="footer-provider-logo"
        icon="nib-powered"
      ></nibtravel-icon>
    </div>
  </div>
</footer>

<ng-template #quickLink let-block="block" let-nav="nav">
  <ul id="footer-quicklink-{{ block }}" class="footer-nav-list">
    <li class="footer-nav-heading">{{ nav.heading }}</li>
    <li class="footer-nav-item" *ngFor="let item of nav.links">
      <a
        class="footer-nav-link link link--inverted"
        [href]="item.linkUrl"
        [rel]="item.linkRel"
        [target]="item.linkTarget || '_blank'"
        >{{ item.linkText }}
      </a>
    </li>
  </ul>
</ng-template>
